/**
 * Step 5 · Density & Cut-Off Setup
 * --------------------------------
 * Combines the pre-existing DensityMatrixEditor (per-lithology density
 * table with AI recommendations + CP sign-off) with the new
 * AutoCutoffPanel (commodity-aware cutoff calculator with sensitivity
 * slider) so the CP can drive both from a single stage.
 */
import { useQuery } from "@tanstack/react-query";
import { getProject } from "@/lib/api";
import DensityMatrixEditor from "@/pages/wizard/DensityMatrixEditor";
import AutoCutoffPanel     from "@/pages/wizard/AutoCutoffPanel";

export default function DensityAndCutoffStep({ projectId }) {
  const projectQ = useQuery({
    queryKey: ["density-cutoff-project", projectId],
    queryFn:  () => getProject(projectId),
    enabled:  !!projectId,
    staleTime: 60_000,
  });
  const commodity = projectQ.data?.commodity || "gold";

  return (
    <div className="max-w-6xl space-y-4" data-testid="density-cutoff-step">
      <DensityMatrixEditor projectId={projectId} />
      <AutoCutoffPanel projectId={projectId} defaultCommodity={commodity} />
    </div>
  );
}
